import React from 'react';
import './frontPage.css';
import { getHomeContent } from '../../services/contentService';

class FrontPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logoUrl: '/content/Home/Logo/Title%201.png'
    };
    // To use the 'this' keyword, we need to bind it to our function
  }

  async componentDidMount() {
    try {
      const home = await getHomeContent();
      if (home.logoUrl) {
        this.setState({ logoUrl: home.logoUrl });
      }
    } catch (_) {
      // Keep fallback logo path when manifest is unavailable.
    }
  }

  render() {
    return (
      <div className="slider">
        <div className="load"></div>
        <div className="matter">
          <div className="principal">
            <div className="logo">
              <img src={this.state.logoUrl} alt="RAW logo" />
            </div>
            {/* <h2>Robust Architecture</h2>
              <h1>WORKSHOP</h1> */}
            <div className="nav-options">
              <ul>
                <li>
                  <a href="/projects">Works</a>
                </li>
                <li>
                  <a href="/about/aboutUs">About</a>
                </li>
                <li>
                  <a href="/contact">Contact</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FrontPage;
